































import { Component, Prop, Vue } from "vue-property-decorator";
import { isMobileOnly } from "mobile-device-detect";

@Component
export default class BgmCreditSnack extends Vue {
  @Prop({ default: false }) isShown: boolean;

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }
}
